import React from "react";

function UserIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      fill="none"
      viewBox="0 0 15 16"
    >
      <path
        fill="url(#paint0_linear_66_80)"
        d="M9.702 8.675c.35-.29.647-.628.892-1.013.245-.385.428-.802.548-1.252.25-.93.23-1.84-.06-2.73a4.537 4.537 0 00-1.538-2.197A3.923 3.923 0 008.39.86a4.009 4.009 0 00-2.587.007 4.14 4.14 0 00-1.163.623 4.436 4.436 0 00-1.537 2.19c-.29.89-.31 1.8-.06 2.73.12.45.302.867.547 1.252.245.385.543.723.893 1.013-1.19.51-2.185 1.32-2.985 2.43A7.758 7.758 0 00.102 14.81c0 .13.012.232.037.307.025.075.063.158.113.248.11.16.27.255.48.285.19.01.362-.045.517-.165a.692.692 0 00.263-.51c.08-.73.277-1.423.592-2.078a5.78 5.78 0 013-2.85 5.222 5.222 0 012.003-.397c.69 0 1.357.132 2.002.397.645.265 1.225.64 1.74 1.125a5.827 5.827 0 011.253 1.718c.32.66.52 1.355.6 2.085.01.18.087.337.232.472a.682.682 0 00.473.203h.075c.2-.03.357-.123.472-.278a.765.765 0 00.143-.547 8.02 8.02 0 00-.458-1.958 7.355 7.355 0 00-.937-1.762 7.493 7.493 0 00-1.35-1.433 6.82 6.82 0 00-1.65-.997zm-2.61-.525c-.56 0-1.078-.17-1.553-.51a2.947 2.947 0 01-1.042-1.35 3.109 3.109 0 01-.173-1.718 2.945 2.945 0 01.773-1.53c.41-.435.892-.712 1.447-.832a2.546 2.546 0 011.628.18c.53.24.952.607 1.267 1.102.315.495.473 1.048.473 1.658a3.1 3.1 0 01-.832 2.123 2.722 2.722 0 01-1.988.877z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_66_80"
          x1="2.327"
          x2="19.447"
          y1="-5.9"
          y2="-0.082"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.5" stopColor="#ADFF00"></stop>
          <stop offset="0.8" stopColor="#CF0"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default UserIcon;
